import React from 'react';
import { BookingProvider } from '../contexts/booking/BookingContext';
import BookingWizard from '../components/booking/BookingWizard';

const Booking: React.FC = () => {
  return (
    <BookingProvider>
      <BookingWizard />
    </BookingProvider>
  );
};

export default Booking;
